import InlineMessage, { type InlineMessageHeadingLevel } from '@ingka/inline-message';
import informationCircleIcon from '@ingka/ssr-icon/paths/information-circle';

interface MessageProps {
    title: string;
    body: string;
    iconAriaLabel?: string;
    headingLevel?: InlineMessageHeadingLevel;
}

/**
 * @param {string} title - `string` - Set title text for the InlineMessage component
 * @param {string} body - `string` - Set body text for the InlineMessage component
 * @returns The message wrapped and rendered using Skapa `<InlineMessage />` component
 */
export const NoBodyMessage = ({ title, body, iconAriaLabel, headingLevel }: MessageProps) => {
    return (
        <InlineMessage
            title={title}
            body={body}
            variant="informative"
            headingLevel={headingLevel ?? '6'}
            ssrIcon={informationCircleIcon}
            data-testid="no-body-message"
            labelMessageType={iconAriaLabel ?? ''}
        />
    );
};
